// src/pages/Classroom.js
import ClassroomView from "../components/classroom/ClassroomView";

const ClassroomPage = () => {
    return (
        <div>
            <ClassroomView />
        </div>
    )
};

export default ClassroomPage;